import { AppApiGateway } from '@repo/api/web/AppApiGateway'
import { BindTelegramDto, WebUserUpdate } from '@repo/api/web/models'
import { inject, injectable } from 'inversify'

import { useUserStore } from '#User/store'

@injectable()
export class UserService {
  private $store: ReturnType<typeof useUserStore>
  protected appConfig: ReturnType<typeof useAppConfig>

  constructor(
    @inject(AppApiGateway)
    readonly api: AppApiGateway,
  ) {
    this.$store = useUserStore()
    this.appConfig = useAppConfig()
  }

  get() {
    return this.api.usersGet(this.appConfig.host)
  }

  async loadCurrentUser() {
    const user = await this.get()
    this.$store.setUser(user)
  }

  getCurrentUser() {
    return this.$store.user
  }

  async updateProfile(model: WebUserUpdate) {
    await this.api.usersUpdate(this.appConfig.host, model)
    await this.loadCurrentUser()
  }

  bindTelegram(): Promise<BindTelegramDto> {
    return this.api.usersBindTelegram(this.appConfig.host)
  }

  /**
   * Checks whether Telegram bot/binding is available for current showcase host.
   */
  async isTelegramBotAvailable(): Promise<boolean> {
    // API gateway type might be a string, but backend contract is boolean.
    // Coercion keeps the UI resilient to minor typing drifts.
    const available = await this.api.usersBindTelegramAvailable(this.appConfig.host)
    return Boolean(available)
  }

  async unbindTelegram() {
    await this.api.usersUnbindTelegram(this.appConfig.host)
    await this.loadCurrentUser()
  }

  resetStore() {
    this.$store.reset()
  }
}
